export enum TransactionType {
  EXPENSE = "EXPENSE",
  INCOME = "INCOME",
}
